export default __webpack_public_path__ + "static/media/6_ideate.af001215.jpg";